<!-- <p>Tareas ejecutadas por {{empresa}}</p>

<p><strong>Total Trabajadores: </strong> {{totalTrabajadores}}</p>
<p><strong>Total PTW: </strong> {{totalPTW}}</p>


<ngx-charts-pie-chart
            [view]="viewPie"
            [scheme]="colorScheme"
            [results]="dataChart"
            [gradient]="gradientPie"
            [legend]="showLegendPie"
            [legendPosition]="legendPositionPie"
            [labels]="showLabelsPie"
            [trimLabels]="trimLabelsPie" 
            [doughnut]="isDoughnutPie"
            >
</ngx-charts-pie-chart> -->


<div class="modal-header">
  <h5 class="modal-title">Reporte general de {{empresa}}</h5>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="container text-center">
  

  <div class="modal-body">
  <div class="content">
      <p><strong>Total Trabajadores: </strong> {{totalTrabajadores}}</p>
      <p><strong>Total PTW: </strong> {{totalPTW}}</p>
    <hr>
      <div class="row">
        <div class="col" style="text-align: center;"> 
          <ngx-charts-pie-chart 
            [view]="viewPie" 
            [scheme]="colorScheme" 
            [results]="dataChart" 
            [gradient]="gradientPie"
            [legend]="showLegendPie" 
            [legendPosition]="legendPositionPie" 
            [labels]="showLabelsPie"
            [trimLabels]="trimLabelsPie" 
            [doughnut]="isDoughnutPie">
          </ngx-charts-pie-chart>
        </div> 
      </div>
      <hr>
      <div class="row">
        <div class="col" style="text-align: center;">
          <p><strong>Códigos PTW:</strong></p>
          <p>{{tickets}}</p>
        </div>
      </div>

  </div>
</div>
  

  
</div>